import BaseComponent from 'scripts/BaseComponent.js';

export default class RelatedProductOption extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      currentProductJson: '.js-productJson',
      relatedProductJson: '.js-relatedProductJson',
      selectedOption: '.js-productOptionBtn.active-option',
    };

    this.dom = {
      $component: component,
    };

    this.state = {
      currentUrl: document.location.pathname,
      relatedProductId: this.dom.$component.dataset.productId,
      relatedProductData: null,
      currentProductData: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClickWithElement(dom.$component, this.relatedProductBtnClick);
  }

  init() {
    this.setState();
  }

  setState() {
    const { state, refs } = this;
    if (state.relatedProductId) {
      const relatedProductJson = document.querySelector(`${refs.relatedProductJson}-${state.relatedProductId}`).innerHTML;
      const currentProductJson = document.querySelector(refs.currentProductJson).innerHTML;
      const relatedProductData = JSON.parse(relatedProductJson);
      const currentProductData = JSON.parse(currentProductJson);
      state.relatedProductData = relatedProductData;
      state.currentProductData = currentProductData;
    }
  }

  relatedProductBtnClick(btn) {
    const { state, refs } = this;
    const { url } = btn.dataset;

    if (url === state.currentUrl) return;

    const selectedOption = document.querySelector(refs.selectedOption);
    const selectedOptionValue = selectedOption.dataset.optionValue.trim();
    const selectedOptionPosition = selectedOption.dataset.optionPosition;
    const relatedProductVariants = state.relatedProductData.variants;
    let relatedProductSelectedVariantId = null;
    relatedProductVariants.forEach((variant) => {
      const optionValue = variant[`option${selectedOptionPosition}`];
      if (optionValue === selectedOptionValue) {
        relatedProductSelectedVariantId = variant.id;
      }
    });

    if (relatedProductSelectedVariantId) {
      window.location.href = `${url}?variant=${relatedProductSelectedVariantId}`;
    } else {
      window.location.href = url;
    }
  }
}
